module.exports = __webpack_public_path__ + "img/40_76.0a443b8d.png";